var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtlassianLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 72,
    viewBox: "0 0 142 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 27,
    width: 142,
    height: 18
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1648 34.9213C5.11282 34.8547 5.04431 34.8023 4.96586 34.7693C4.88741 34.7363 4.80166 34.7238 4.71687 34.7329C4.63207 34.742 4.55108 34.7725 4.48169 34.8213C4.4123 34.8702 4.35685 34.9359 4.32066 35.0121L0.0526139 43.4233C0.0178366 43.5005 0.00270917 43.5849 0.00854694 43.6691C0.0143847 43.7534 0.0410109 43.8349 0.0861106 43.9067C0.13121 43.9785 0.193418 44.0384 0.267326 44.0811C0.341233 44.1237 0.424603 44.148 0.510186 44.1517H6.45337C6.54827 44.1537 6.64172 44.1286 6.72245 44.0793C6.80317 44.0301 6.86773 43.9589 6.90831 43.8744C8.19162 41.2615 7.41322 37.2957 5.1648 34.9213Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29424 27.2695C7.23099 28.8827 6.61135 30.7405 6.4961 32.6609C6.38084 34.5812 6.77393 36.4982 7.6368 38.2236L10.5032 43.8744C10.5458 43.958 10.6111 44.0282 10.692 44.0772C10.7728 44.1262 10.8659 44.152 10.9608 44.1517H16.9013C16.9885 44.152 17.0743 44.1302 17.1505 44.0885C17.2267 44.0469 17.2908 43.9866 17.3367 43.9136C17.3825 43.8405 17.4087 43.7571 17.4126 43.6713C17.4165 43.5855 17.398 43.5001 17.3589 43.4233C17.3589 43.4233 9.36454 27.6609 9.16205 27.2669C9.12257 27.1864 9.06081 27.1186 8.98389 27.0712C8.90697 27.0238 8.81803 26.9988 8.72731 26.999C8.6366 26.9993 8.54781 27.0248 8.47119 27.0727C8.39456 27.1206 8.33322 27.1888 8.29424 27.2695Z",
    fill: "#7B869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.514 30.0405V44.1518H132.565V33.3921L133.85 36.2485L138.163 44.1518H142V30.0405H138.95V39.1491L137.792 36.5052L134.329 30.0405H129.514Z",
    fill: "#7B869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.112 30.0405H106.777V44.1518H110.112V30.0405Z",
    fill: "#7B869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.943 39.9865C102.943 37.5162 101.612 36.3576 97.865 35.5618C95.7954 35.1108 95.2958 34.6597 95.2958 34.0065C95.2958 33.19 96.0347 32.8479 97.3996 32.8479C99.0563 32.8479 100.689 33.3404 102.238 34.0273V30.7924C100.753 30.1265 99.136 29.7962 97.5048 29.8255C93.7995 29.8255 91.8824 31.4171 91.8824 34.0143C91.8824 36.088 92.8633 37.7521 96.6974 38.4831C98.9853 38.9548 99.4639 39.3203 99.4639 40.072C99.4639 40.8237 98.9853 41.2747 97.3733 41.2747C95.4254 41.2396 93.5165 40.7303 91.8167 39.7921V43.1851C92.9711 43.745 94.4963 44.3671 97.3391 44.3671C101.349 44.3671 102.94 42.6071 102.94 39.9865",
    fill: "#7B869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0502 39.9865C89.0502 37.5163 87.7222 36.3576 83.9748 35.5619C81.9052 35.1108 81.403 34.6598 81.403 34.0066C81.403 33.1901 82.1445 32.848 83.5067 32.848C85.1635 32.848 86.7965 33.3405 88.3428 34.0274V30.7924C86.8579 30.126 85.2406 29.7957 83.6093 29.8256C79.9066 29.8256 77.9896 31.4171 77.9896 34.0144C77.9896 36.0881 78.9678 37.7522 82.8046 38.4831C85.0925 38.9549 85.5711 39.3204 85.5711 40.0721C85.5711 40.8238 85.0925 41.2748 83.4804 41.2748C81.5325 41.2397 79.6237 40.7303 77.9238 39.7921V43.1852C79.0783 43.745 80.6035 44.3671 83.4462 44.3671C87.4566 44.3671 89.0449 42.6071 89.0449 39.9865",
    fill: "#7B869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1078 30.0405V44.1518H58.9609L60.039 41.1035H55.4633V30.0405H52.1078Z",
    fill: "#7B869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5703 30.0405V33.0914H42.273V44.1518H45.6285V33.0914H49.5941V30.0405H38.5703Z",
    fill: "#7B869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7026 30.0376H29.3109L24.3145 44.1514H28.1276L28.835 41.7745C30.5776 42.2793 32.4307 42.2793 34.1733 41.7745L34.8807 44.1514H38.6938L33.7026 30.0376ZM31.5041 39.2291C30.8811 39.2298 30.2612 39.1426 29.6633 38.9699L31.5041 32.8085L33.3449 38.9699C32.7473 39.1438 32.1273 39.232 31.5041 39.2317V39.2291Z",
    fill: "#7B869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7709 30.0376H66.374L61.3776 44.1489H65.1907L65.8981 41.7719C67.6407 42.2767 69.4938 42.2767 71.2364 41.7719L71.9438 44.1489H75.7569L70.7709 30.0376ZM68.5725 39.2317C67.9495 39.2324 67.3296 39.1451 66.7317 38.9725L68.5725 32.8111L70.4133 38.9725C69.8154 39.1451 69.1955 39.2324 68.5725 39.2317Z",
    fill: "#7B869A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.125 30.0376H117.725L112.729 44.1489H116.542L117.249 41.7719C118.992 42.2772 120.847 42.2772 122.59 41.7719L123.297 44.1489H127.11L122.125 30.0376ZM119.926 39.2291C119.303 39.2302 118.683 39.1429 118.085 38.9699L119.926 32.8085L121.767 38.9699C121.169 39.1438 120.549 39.232 119.926 39.2317V39.2291Z",
    fill: "#7B869A"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 72,
    fill: "#1B2738"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.50263,
    y1: 36.22,
    x2: 3.09465,
    y2: 43.9657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#364765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#7B869A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 142,
    height: 17.3669,
    fill: "white",
    transform: "translate(0 27)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlassianLogo);
export default __webpack_public_path__ + "static/media/atlassian_logo.e330a2688b49cf890e769cdba1244753.svg";
export { ForwardRef as ReactComponent };